var ShareLinkWatcher = (function ($) {
    ShareLinkWatcher = function () {
        var that = this;
        that.selector = '.js-share';
        that.data_attributes = {
            link_share_url: 'link-share-url',
            link_share_title: 'link-share-title',
            link_share_description: 'link-share-description',
            link_share_image: 'link-share-image',
            link_share_services: 'link-share-services',
        };

        that._init();
    };

    ShareLinkWatcher.prototype._init = function () {
        var that = this;
        $.sa.$document.on('click', that.selector, function (e) {
            e.preventDefault();
            var $self = $(this),
                link_share_title = $self.data(that.data_attributes.link_share_title),
                link_share_description = $self.data(that.data_attributes.link_share_description),
                link_share_services = $self.data(that.data_attributes.link_share_services),
                link_share_image = $self.data(that.data_attributes.link_share_image),
                share_options = {
                    url: $self.data(that.data_attributes.link_share_url) || window.location.href
                };

            if (link_share_title) {
                share_options.title = link_share_title;
            }

            if (link_share_description) {
                share_options.description = link_share_description;
            }

            if (link_share_image) {
                share_options.image = link_share_image;
            }

            if (link_share_services) {
                if (typeof link_share_services === 'string') {
                    link_share_services = link_share_services.explode(',').map(s => s.trim());
                }
                share_options.services = link_share_services;
            }

            $.sa.share(share_options);
        });
    };

    return ShareLinkWatcher;
})(jQuery);
